"use strict";

export default function () {
    window.addEventListener("DOMContentLoaded", () => {
        const carrossel = document.getElementById("heroCarrossel");
        const items = [...carrossel.children];
        const itemCount = items.length;

        items.forEach((item) => {
            const clone = item.cloneNode(true);
            carrossel.appendChild(clone);
        });

        carrossel.style.display = "flex";
        carrossel.style.overflow = "hidden";
        carrossel.style.position = "relative";
        carrossel.style.willChange = "transform";

        let translateX = 0;
        const speed = 0.3;

        function animate() {
            translateX -= speed;
            carrossel.style.transform = `translateX(${translateX}px)`;

            const firstItemWidth =
                items[0].offsetWidth +
                parseInt(getComputedStyle(items[0]).marginRight);

            if (Math.abs(translateX) >= firstItemWidth * itemCount) {
                translateX = 0;
                carrossel.style.transform = `translateX(${translateX}px)`;
            }

            requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);
    });
}
